import { merge } from 'ramda';
import Utils from 'src/utils';
import dayjs from 'dayjs';
import { loadExcelExport } from 'src/store/actions/excelActions';
import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import communicate from 'src/api/communicate';

export const LOAD_ALL_USER_RIGHT_REQUEST = 'LOAD_ALL_USER_RIGHT_REQUEST';
export const LOAD_ALL_USER_RIGHT_FAIL = 'LOAD_ALL_USER_RIGHT_FAIL';
export const LOAD_ALL_USER_RIGHT_SUCCESS = 'LOAD_ALL_USER_RIGHT_SUCCESS';

export const LOAD_DEFAULT_USER_RIGHT_REQUEST = 'LOAD_DEFAULT_USER_RIGHT_REQUEST';
export const LOAD_DEFAULT_USER_RIGHT_FAIL = 'LOAD_DEFAULT_USER_RIGHT_FAIL';
export const LOAD_DEFAULT_USER_RIGHT_SUCCESS = 'LOAD_DEFAULT_USER_RIGHT_SUCCESS';

export const PUT_USER_RIGHT_REQUEST = 'PUT_USER_RIGHT_REQUEST';
export const PUT_USER_RIGHT_FAIL = 'PUT_USER_RIGHT_FAIL';
export const PUT_USER_RIGHT_SUCCESS = 'PUT_USER_RIGHT_SUCCESS';

export const POST_USER_RIGHT_REQUEST = 'POST_USER_RIGHT_REQUEST';
export const POST_USER_RIGHT_FAIL = 'POST_USER_RIGHT_FAIL';
export const POST_USER_RIGHT_SUCCESS = 'POST_USER_RIGHT_SUCCESS';

export const SET_USER_RIGHT_GROUP = 'SET_USER_RIGHT_GROUP';

export const SET_DEFAULT_USER_RIGHTS = 'SET_DEFAULT_USER_RIGHTS';

export const DELETE_USER_RIGHT_REQUEST = 'DELETE_USER_RIGHT_REQUEST';
export const DELETE_USER_RIGHT_FAIL = 'DELETE_USER_RIGHT_FAIL';
export const DELETE_USER_RIGHT_SUCCESS = 'DELETE_USER_RIGHT_SUCCESS';

export const RESET_USER_RIGHT_DATA = 'RESET_USER_RIGHT_DATA';
export const RESET_USER_RIGHT_GROUP_INFO = 'RESET_USER_RIGHT_GROUP_INFO';

const loadAllUserRightRequest = () => ({ type: LOAD_ALL_USER_RIGHT_REQUEST });
const loadAllUserRightFail = (err) => ({ type: LOAD_ALL_USER_RIGHT_FAIL, err });
const loadAllUserRightSuccess = (data) => ({ type: LOAD_ALL_USER_RIGHT_SUCCESS, data });

const loadDefaultUserRightRequest = () => ({ type: LOAD_DEFAULT_USER_RIGHT_REQUEST });
const loadDefaultUserRightFail = (err) => ({ type: LOAD_DEFAULT_USER_RIGHT_FAIL, err });

const putUserRightsRequest = () => ({ type: PUT_USER_RIGHT_REQUEST });
const putUserRightsFail = (err) => ({ type: PUT_USER_RIGHT_FAIL, err });
const putUserRightsSuccess = (data) => ({ type: PUT_USER_RIGHT_SUCCESS, data });

const postUserRightsRequest = () => ({ type: POST_USER_RIGHT_REQUEST });
const postUserRightsFail = (err) => ({ type: POST_USER_RIGHT_FAIL, err });
const postUserRightsSuccess = (data) => ({ type: POST_USER_RIGHT_SUCCESS, data });

export const setDefaultUserRights = (data) => ({ type: SET_DEFAULT_USER_RIGHTS, data });

export const setUserRightsGroup = (data) => ({ type: SET_USER_RIGHT_GROUP, data });
export const resetUserRightsData = () => ({ type: RESET_USER_RIGHT_DATA });
export const resetUserRightsGroupInfo = () => ({ type: RESET_USER_RIGHT_GROUP_INFO });

const deleteUserRightsRequest = () => ({ type: DELETE_USER_RIGHT_REQUEST });
const deleteUserRightsFail = (err) => ({ type: DELETE_USER_RIGHT_FAIL, err });
const deleteUserRightsSuccess = (groupId) => ({ type: DELETE_USER_RIGHT_SUCCESS, groupId });

export const loadAllUserRights = () => (dispatch) => {
  dispatch(loadAllUserRightRequest());
  return communicate({
    url: 'UserGroupRights',
    method: 'get'
  }).then((response) => {
    dispatch(loadAllUserRightSuccess(response.data.Data));
  }).catch((err) => {
    dispatch(loadAllUserRightFail(err));
    toastrError(err);
  });
};

export const loadDefaultRights = () => (dispatch) => {
  dispatch(loadDefaultUserRightRequest());
  return communicate({
    url: 'Rights',
    method: 'get'
  }).then((response) => {
    dispatch(setUserRightsGroup(merge({ Name: '' }, { Rights: response.data.Data })));
    dispatch(setDefaultUserRights(response.data.Data));
  }).catch((err) => {
    dispatch(loadDefaultUserRightFail(err));
    toastrError(err);
  });
};

export const putUserRights = (params) => (dispatch) => {
  dispatch(putUserRightsRequest());
  return communicate({
    url: 'UserGroupRights',
    method: 'put',
    data: params
  }).then((response) => {
    dispatch(setUserRightsGroup(response.data.Data));
    dispatch(putUserRightsSuccess(response.data.Data));
    // dispatch(loadUserInfo());
    toastrSuccess(response);
    return response.data.Data;
  }).catch((err) => {
    dispatch(putUserRightsFail(err));
    toastrError(err);
  });
};

export const postUserRights = (params) => (dispatch) => {
  dispatch(postUserRightsRequest());
  return communicate({
    url: 'UserGroupRights',
    method: 'post',
    data: params
  }).then((response) => {
    dispatch(setUserRightsGroup(response.data.Data));
    dispatch(postUserRightsSuccess(response.data.Data));
    toastrSuccess(response);
    return response.data.Data;
  }).catch((err) => {
    dispatch(postUserRightsFail(err));
    toastrError(err);
  });
};

export const deleteUserRightsGroup = (params) => (dispatch) => {
  dispatch(deleteUserRightsRequest());
  return communicate({ url: 'UserGroups', method: 'delete', getParams: `?id=${params}` })
    .then((response) => {
      toastrSuccess(response);
      dispatch(deleteUserRightsSuccess(params));
    }).catch((err) => {
      dispatch(deleteUserRightsFail(err));
      toastrError(err);
    });
};

export const loadExcel = (params) => (dispatch) => {
  const request = {
    url: 'UserGroupRights/ToExcel',
    query: Utils.objects.getQueryStringFromObject({
      ...params,
      currentDateTime: dayjs().format('YYYY-MM-DD[T]HH:mm:ss')
    })
  };
  return dispatch(loadExcelExport(request));
};
